import { observer } from 'mobx-react';

import { Document } from '@roc/feature-types';
import { InspectionReportDialog, PointOfContactDialog } from '@roc/feature-draws';
import { TaskStatus } from '@roc/feature-general-tasks';

interface RealValPropertyPhotosDialogProps {
  open: boolean;
  onClose: () => void;
  document: Document;
}

export const RealValPropertyPhotosDialog = observer(({ open, onClose, document }: RealValPropertyPhotosDialogProps) => {
  const isPending = document?.status === TaskStatus.PENDING;
  return isPending ? (
    <PointOfContactDialog
      open={open}
      onClose={onClose}
      document={document}
      isInternalValuationPropertyPhotosContactFlow
    />
  ) : (
    <InspectionReportDialog
      open={open}
      onClose={onClose}
      document={document}
      isInternalValuationPropertyPhotosContactFlow />
  );
});
